
//Date formats
export const dateFormats = {
  DATE: 'MMM d yyyy',
  TIME: 'h:mm a',
  TIME_24: 'HH:mm',
  DATE_AND_TIME: 'MMM d yyyy, h:mm a',
  ISO: 'yyyy-MM-dd',
}
